import {ChangeMenuActionInterface, MenuActionTypesEnum} from "./MenuTypes";

export function changeMenuActions(activeElement: number | boolean, isOpenMenu: boolean): ChangeMenuActionInterface {
    return {
        type: MenuActionTypesEnum.CHANGE_MENU,
        activeElement,
        isOpenMenu,
    };
}
